// @flow

import React, {PureComponent} from 'react';
import type { Element } from 'react';
import styled from 'styled-components';

type Props = {
  children: Array<Element<*>> | Element<*> | string,
  hasPadding: bool
};

// Default false for not within DescriptionContext
const DescriptionContext = React.createContext(false);

export const DescriptionChild = DescriptionContext.Consumer;

const Description = styled.div`
  color: #6d6d72;
  font-size: 13px;
  line-height: 1.4;
  padding: 7px ${({hasPadding}) => hasPadding ? '15px' : '0'} 0;
  word-wrap: break-word;
`;

export default class extends PureComponent<Props, void> {
  static _type = 'Description';

  render() {
    const {children, hasPadding} = this.props;

    return (
      // Set to true when within DescriptionContext
      <DescriptionContext.Provider value={true}>
        <Description hasPadding={hasPadding}>
          {children}
        </Description>
      </DescriptionContext.Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/description.js